import { render } from "./BatchDownloadLink.vue?vue&type=template&id=6e6b7f4d&scoped=true"
import script from "./BatchDownloadLink.vue?vue&type=script&lang=js"
export * from "./BatchDownloadLink.vue?vue&type=script&lang=js"

import "./BatchDownloadLink.vue?vue&type=style&index=0&id=6e6b7f4d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6b7f4d"]])

export default __exports__